import { radioCardStyles } from './radio-card.styles';
import { NatGenRadio } from '../radio/radio';
import { radioCardTemplate } from './radio-card.template';
import { checkIcon } from '../../styles/icons';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { RadioOptions } from '../radio/radio.options';
import { StartEnd, StartEndOptions } from '../start-end/start-end';
import { applyMixins } from '../../foundation/apply-mixins';

export type RadioCardOptions = RadioOptions & StartEndOptions;

/**
 * @element natgen-radio-card
 */
export class NatGenRadioCard extends NatGenRadio {

}

export const natGenRadioCardDefinition = NatGenRadioCard.compose({
    name: `${NatGenDesignSystem.prefix}-radio-card`,
    template: radioCardTemplate({
        checkedIndicator: checkIcon
    }),
    styles: radioCardStyles
});

applyMixins(NatGenRadioCard, StartEnd);
